var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 52,
    viewBox: "0 0 54 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 33.5049,
    cy: 31.9527,
    r: 20,
    fill: "#473BF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2002_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1875 2.5625C28.8671 2.5625 29.5189 2.83248 29.9995 3.31304C30.48 3.7936 30.75 4.44538 30.75 5.125V35.875C30.75 36.5546 30.48 37.2064 29.9995 37.687C29.5189 38.1675 28.8671 38.4375 28.1875 38.4375H12.8125C12.1329 38.4375 11.4811 38.1675 11.0005 37.687C10.52 37.2064 10.25 36.5546 10.25 35.875V5.125C10.25 4.44538 10.52 3.7936 11.0005 3.31304C11.4811 2.83248 12.1329 2.5625 12.8125 2.5625H28.1875ZM12.8125 0C11.4533 0 10.1497 0.539954 9.18858 1.50108C8.22745 2.4622 7.6875 3.76577 7.6875 5.125V35.875C7.6875 37.2342 8.22745 38.5378 9.18858 39.4989C10.1497 40.46 11.4533 41 12.8125 41H28.1875C29.5467 41 30.8503 40.46 31.8114 39.4989C32.7725 38.5378 33.3125 37.2342 33.3125 35.875V5.125C33.3125 3.76577 32.7725 2.4622 31.8114 1.50108C30.8503 0.539954 29.5467 0 28.1875 0L12.8125 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 35.875C21.1796 35.875 21.8314 35.605 22.312 35.1245C22.7925 34.6439 23.0625 33.9921 23.0625 33.3125C23.0625 32.6329 22.7925 31.9811 22.312 31.5005C21.8314 31.02 21.1796 30.75 20.5 30.75C19.8204 30.75 19.1686 31.02 18.688 31.5005C18.2075 31.9811 17.9375 32.6329 17.9375 33.3125C17.9375 33.9921 18.2075 34.6439 18.688 35.1245C19.1686 35.605 19.8204 35.875 20.5 35.875Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2002_62"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApps);
export default __webpack_public_path__ + "static/media/icon-apps.ac64f9eeed91484c4774d0e7cbc404e6.svg";
export { ForwardRef as ReactComponent };